function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaced(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "25.49 6.5 10.49 7.5 14.5 11.5 6.51 19.5 12.51 25.5 20.49 17.49 24.49 21.5 25.49 6.5",
    style: {
      fill: "#00a6e7"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaced);
export default __webpack_public_path__ + "static/media/placed.95429841.svg";
export { ForwardRef as ReactComponent };